import {IToolsService} from "./tools.service.interface";
import {ServiceBase} from "../ServiceBase";
import { v4 as uuidv4 } from 'uuid';

export class ToolsService extends ServiceBase implements IToolsService{
    getGuid(): string {
      return uuidv4();
    }
}